<template>
    <div class="select-product-or-points" v-if="isShow">
        <p>
            因 {{ giveGoodsObj.goodsName }} 请选择:
        </p>
        <div>
            <el-radio style="width: 100%;" border v-model="radio" label="1" @input="radioChange">产品</el-radio>
        </div>
        <div style="margin-top: 10px;">
            <el-radio style="width: 100%;" border v-model="radio" label="2" @input="radioChange">积分</el-radio>
        </div>
    </div>
</template>

<script>

export default {
    name: 'SelectProductOrPoints',
    props: {
        value: {
            type: String,
            default: ''
        },
        //触发赠送的产品及赠送产品可选择的数量
        giveGoodsObj: {
            type: Object,
            default: () => {
                return {
                    goodsCode: '',
                    goodsName: '',
                    giveNum: 0
                }
            }
        },
        //购买的产品列表
        goodsList: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    data() {
        return {
            radio: this.value || ''
        }
    },
    computed: {
        isShow() {
            if (!this.goodsList.length) {
                return false
            }
            let isShow = false
            let good = this.goodsList.find(item => item.code === this.giveGoodsObj.goodsCode)

            if (good) {
                isShow = (good.quantity || good.buyQty) > 0
            }
            return isShow
        },
    },
    watch: {
        // value: {
        //     immediate: true,
        //     handler(val) {
        //         this.radio = val
        //     }
        // }
    },
    created() {},
    methods: {
        radioChange() {
            this.$emit('input', this.radio)
        }
    }


}
</script>

<style lang="scss" scoped>
.select-product-or-points {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 20px;
    margin-bottom: 10px;
}

.error-msg {
    color: red;
}
</style>